import React from "react";
import StripeCheckout from '../stripeCheckout';
import {Elements, StripeProvider} from 'react-stripe-elements';
import { Modal, FormGroup, ControlLabel, FormControl, Button, form, Panel, Checkbox, Table } from 'react-bootstrap';





export default function StripeGateway(props) {
  var payment_field = []
      // TODO: What is setting the paymentStatus state?
      if(props.paymentStatus === null || props.paymentStatus === "error" || props.paymentStatus === 'declined' ){
  
          payment_field.push(
            <div className="enrolment-payment-card payment-field">
              {/* <div>
                <ControlLabel  style={{display: "flex", fontSize: "20px", alignItems: "center"}}>
                  <img src="5.png" style={{ height: '30px', width: '30px'}} />&nbsp;
                    Payment 
                </ControlLabel>
              </div> */}
              <Elements>
                <StripeCheckout  
                stripeDecline={props.stripeDecline}
                patchReceipt={props.patchReceipt} 
                setSpinner={props.setSpinner} 
                name={props.name} stripeEndPoint={props.stripeEndPoint} 
                email={props.email} 
                pay_spinner={props.pay_spinner} 
                pricingBreakdown={props.pricingBreakdown}
                currencyType={props.currencyType} 
                account={props.account}
                />
              </Elements>
            </div>)
      } else if (props.paymentStatus === 'waitlist'){
        payment_field.push(
          <div className="white-text approved-display">
              <img src="smiley.png" style={{ height: '60px', width: '60px'}} />&nbsp;
              <span style={{fontSize: "14px"}}>{`You've joined the waitlist for ${props.selected_program.group_name}`}</span><br/>
              <div style={{ width: "80%", display: "flex", justifyContent: "center"}}>
                <Button style={{width: "95%"}} className="orange-outline pay-button" onClick={props.handleRefresh}>
                  Complete Another Enrolment
                </Button>
              </div>
              <br/>
              <div style={{ width: "80%", display: "flex", justifyContent: "space-around"}}>
                <Button style={{width: "45%"}} className="orange-outline pay-button" onClick={props.handleApprovedSignOut}>
                  Sign Out
                </Button>
                <Button style={{width: "45%"}} className="orange-outline pay-button" onClick={props.handleApprovedRedirect}>
                  See Parent Portal
                </Button>
              </div>
            </div>)
            } else if (props.paymentStatus === 'approved'){
                payment_field.push(
                  <div className="white-text approved-display">
                      <img src="smiley.png" style={{ height: '60px', width: '60px'}} />&nbsp;
                      <span className="mobile-title" style={{fontSize: "25px"}}>Payment Complete!</span>
                      <span className="mobile-title" style={{fontSize: "25px"}}>Thank You</span><br/>
                      <span style={{fontSize: "14px"}}>{props.email?`A confirmation email has been sent to ${props.email}`:"A confirmation email has been sent."}</span><br/>
                      <div style={{ width: "80%", display: "flex", justifyContent: "center"}}>
                        <Button style={{width: "95%"}} className="orange-outline pay-button" onClick={props.handleRefresh}>
                          Complete Another Enrolment
                        </Button>
                      </div>
                      <br/>
                      <div class="row" style={{width: "100%"}}>
                        <div class="col-md-6 col-sm-12">
                          <Button style={{width: "100%", marginBottom: "20px"}} className="orange-outline pay-button" onClick={props.handleApprovedSignOut}>
                            Sign Out
                          </Button>
                        </div>
                        <div class="col-md-6 col-sm-12">
                          <Button style={{width: "100%"}} className="orange-outline pay-button" onClick={props.handleApprovedRedirect}>
                            See Parent Portal
                          </Button>                          
                        </div>
                      </div>
                    </div>)
              }

return payment_field
}


